/* Oasis Land: keep internal links inside the visitor's current market and host.
   Small, defensive and idempotent. Config comes from snippets/oasis-market-links.liquid. */
(function () {
  'use strict';
  try {
    if (window.Shopify && window.Shopify.designMode) return;
    var cfg = window.OasisMarket || {};
    var ROOT = String(cfg.root || '').replace(/\/$/, '');
    var origin = window.location.origin;
    if (!origin || origin === 'null') return;
    var INTERNAL_HOSTS = { 'oasis-land.com': 1, 'www.oasis-land.com': 1, 'oasis-land.ky': 1, 'www.oasis-land.ky': 1 };
    var MARKET_PREFIX = /^\/en-(us|ca|ae)(?=\/|$)/i;
    var SKIP_PATH = /^\/(checkouts?|cdn|apps|tools|admin|a|services|payments|wallets|cart\/c|[0-9]+\/checkouts)(\/|$)/i;
    var REWRITE_PATH = /^\/(collections|products|pages|blogs|cart|search|account|policies)(\/|$)|^\/$/i;
    var SKIP_SCHEME = /^(mailto:|tel:|sms:|javascript:|whatsapp:|data:|blob:)/i;

    function rewrite(a) {
      try {
        if (!a || typeof a.getAttribute !== 'function') return;
        if (a.hasAttribute('data-no-market-rewrite') || a.hasAttribute('data-market-switch')) return;
        if (a.closest && a.closest('[data-no-market-rewrite]')) return;
        var raw = a.getAttribute('href');
        if (!raw) return;
        raw = raw.trim();
        if (!raw || raw.charAt(0) === '#' || SKIP_SCHEME.test(raw)) return;
        var u;
        try { u = new URL(raw, origin); } catch (e) { return; }
        if (u.protocol !== 'http:' && u.protocol !== 'https:') return;
        var host = u.hostname.toLowerCase();
        var sameOrigin = u.origin === origin;
        if (!sameOrigin && !INTERNAL_HOSTS[host]) return;
        var path = u.pathname || '/';
        if (SKIP_PATH.test(path)) return;
        var stripped = path.replace(MARKET_PREFIX, '') || '/';
        if (!REWRITE_PATH.test(stripped)) return;
        var newPath = ROOT ? ROOT + (stripped === '/' ? '' : stripped) : stripped;
        if (sameOrigin && newPath === path) return;
        var newHref = origin + newPath + u.search + u.hash;
        if (a.getAttribute('href') !== newHref) a.setAttribute('href', newHref);
      } catch (e) { /* never break the page for a link */ }
    }

    function scan(root) {
      var scope = root && root.querySelectorAll ? root : document;
      if (scope !== document && scope.matches && scope.matches('a[href]')) rewrite(scope);
      var links = scope.querySelectorAll('a[href]');
      for (var i = 0; i < links.length; i++) rewrite(links[i]);
    }

    var pending = null;
    var queue = [];
    function flush() {
      pending = null;
      var items = queue; queue = [];
      for (var i = 0; i < items.length; i++) scan(items[i]);
    }
    function observe() {
      if (!('MutationObserver' in window) || !document.body) return;
      var mo = new MutationObserver(function (records) {
        for (var r = 0; r < records.length; r++) {
          var added = records[r].addedNodes;
          for (var n = 0; n < added.length; n++) {
            if (added[n].nodeType === 1) queue.push(added[n]);
          }
        }
        if (queue.length && !pending) pending = setTimeout(flush, 150);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
    function start() { scan(document); observe(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  } catch (e) { /* silent */ }
})();
